// extracted by mini-css-extract-plugin
export default {"item":"AddOnsItem_item__-1vsw","itemDevider":"AddOnsItem_itemDevider__S3Wwd","colPrice":"AddOnsItem_colPrice__LSHdw","itemRow":"AddOnsItem_itemRow__Ov3wO"};